import {Component, computed, HostBinding, inject, input, signal} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {WineProduct} from '@core/interfaces/generated/graphql';
import {CountdownLiveComponent} from '@layout/components/product/countdown-live/countdown-live.component';
import {ProductService} from '@core/services/product.service';


@Component({
  selector: 'app-product-top-cta',
  templateUrl: './product-top-cta.component.html',
  styleUrls: ['./product-top-cta.component.scss'],
  imports: [NgOptimizedImage, CountdownLiveComponent]
})
export class ProductTopCtaComponent {
  protected productService = inject(ProductService);


  product = input.required<WineProduct | undefined>();
  maxDiscountDate = this.productService.getMaxDiscountDateSignal(this.product);
  showTopCta = signal(true);

  @HostBinding('class.hide') get hide() {
    return !this.showTopCta();
  }

  topCta = computed(() => this.product()?.topCta);
  iconSrc = computed(() => {
    const icon = this.topCta()?.icon;
    if (icon === 'CTA_WINE_BOTTLE') {
      return '/assets/images/wine-bottle-cta-icon.png';
    }
    if (icon === 'CTA_DISCOUNT_TAG') {
      return '/assets/images/price_tag.png';
    }
    return '';
  })

  toggleVisibility(show: boolean) {
    this.showTopCta.set(show);
  }

}
